import { render, staticRenderFns } from "./PointExpiration.vue?vue&type=template&id=155c7928&scoped=true"
import script from "./PointExpiration.vue?vue&type=script&lang=js"
export * from "./PointExpiration.vue?vue&type=script&lang=js"
import style0 from "./PointExpiration.vue?vue&type=style&index=0&id=155c7928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c7928",
  null
  
)

export default component.exports